import React, { useState } from 'react';
import { Plus, Save, X, Package, DollarSign, Layers, Users, Check } from 'lucide-react';
export function AddProduct() {
  const [fulfillment, setFulfillment] = useState('NiishEngine Design Team');
  return <div className="max-w-4xl mx-auto space-y-8" data-id="element-127">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-128">
        <div className="flex items-center gap-4" data-id="element-129">
          <div className="p-3 bg-indigo-50 text-indigo-600 rounded-lg" data-id="element-130">
            <Package size={24} data-id="element-131" />
          </div>
          <div data-id="element-132">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-133">
              Create Custom Service
            </h1>
            <p className="text-sm text-gray-500 font-medium" data-id="element-134">
              Define your own partner services and fulfillment rules.
            </p>
          </div>
        </div>
        <div className="flex gap-3" data-id="element-135">
          <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-136">
            <Save size={18} data-id="element-137" />
            Save Product
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-138">
        <div className="md:col-span-2 space-y-6" data-id="element-139">
          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm space-y-6" data-id="element-140">
            <div className="space-y-2" data-id="element-141">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-142">
                Product Name
              </label>
              <input type="text" placeholder="e.g. Monthly SEO Audit" className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-143" />
            </div>

            <div className="space-y-2" data-id="element-144">
              <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-145">
                Description
              </label>
              <textarea placeholder="Describe the service value..." className="w-full h-32 p-4 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none resize-none" data-id="element-146" />
            </div>

            <div className="grid grid-cols-2 gap-6" data-id="element-147">
              <div className="space-y-2" data-id="element-148">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-149">
                  Retail Price
                </label>
                <div className="relative" data-id="element-150">
                  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 font-bold" data-id="element-151">
                    $
                  </span>
                  <input type="number" placeholder="0.00" className="w-full pl-8 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-152" />
                </div>
              </div>
              <div className="space-y-2" data-id="element-153">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-154">
                  Billing Cycle
                </label>
                <select className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-indigo-500/20 outline-none appearance-none" data-id="element-155">
                  <option data-id="element-156">One-time</option>
                  <option data-id="element-157">Monthly Recurring</option>
                  <option data-id="element-158">Annual Recurring</option>
                </select>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg border border-gray-200 shadow-sm space-y-6" data-id="element-159">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-160">
              Fulfillment Category
            </h3>
            <div className="grid grid-cols-2 gap-4" data-id="element-161">
              {[{
              id: 'NiishEngine Design Team',
              icon: Layers,
              desc: 'Automated fulfillment by NiishEngine experts.'
            }, {
              id: 'Partner Self-Fulfill',
              icon: Users,
              desc: 'You handle the delivery and support.'
            }].map(item => <button key={item.id} onClick={() => setFulfillment(item.id)} className={`p-4 rounded-lg border-2 text-left transition-all ${fulfillment === item.id ? 'border-indigo-600 bg-indigo-50/50' : 'border-gray-100 hover:border-gray-200'}`} data-id="element-162">
                  <div className="flex items-center justify-between mb-2" data-id="element-163">
                    <item.icon size={20} className={fulfillment === item.id ? 'text-indigo-600' : 'text-gray-400'} data-id="element-164" />
                    {fulfillment === item.id && <Check size={16} className="text-indigo-600" data-id="element-165" />}
                  </div>
                  <p className="text-sm font-bold text-slate-900" data-id="element-166">{item.id}</p>
                  <p className="text-[10px] text-gray-500 font-medium mt-1" data-id="element-167">
                    {item.desc}
                  </p>
                </button>)}
            </div>
          </div>
        </div>

        <div className="space-y-6" data-id="element-168">
          <div className="bg-slate-900 p-6 rounded-lg text-white space-y-4" data-id="element-169">
            <h3 className="text-sm font-bold" data-id="element-170">Profit Preview</h3>
            <div className="space-y-3" data-id="element-171">
              <div className="flex justify-between text-xs" data-id="element-172">
                <span className="text-slate-400" data-id="element-173">Retail Price</span>
                <span className="font-bold" data-id="element-174">$0.00</span>
              </div>
              <div className="flex justify-between text-xs" data-id="element-175">
                <span className="text-slate-400" data-id="element-176">NiishEngine Fee</span>
                <span className="font-bold text-red-400" data-id="element-177">-$0.00</span>
              </div>
              <div className="h-[1px] bg-slate-800" data-id="element-178"></div>
              <div className="flex justify-between text-sm" data-id="element-179">
                <span className="font-bold text-indigo-400" data-id="element-180">Your Profit</span>
                <span className="font-bold text-indigo-400" data-id="element-181">$0.00</span>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm space-y-4" data-id="element-182">
            <h3 className="text-sm font-bold text-slate-900" data-id="element-183">Visibility</h3>
            <div className="flex items-center justify-between" data-id="element-184">
              <span className="text-xs font-medium text-gray-500" data-id="element-185">
                Publish to Storefront
              </span>
              <div className="w-10 h-5 bg-indigo-600 rounded-full relative" data-id="element-186">
                <div className="absolute right-1 top-1 w-3 h-3 bg-white rounded-full" data-id="element-187"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}